export const GRUBHUB_PLUS_LABEL = 'Grubhub+';
export const SEAMLESS_PLUS_LABEL = 'Seamless+';
